import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'

export default {
    name: 'PayableList',
    created,
    data,
    methods
}
